<template>
  <g>
    <path
      d="M7.2 17.6002C8.96731 17.6002 10.4 16.1675 10.4 14.4002C10.4 12.6329 8.96731 11.2002 7.2 11.2002C5.43269 11.2002 4 12.6329 4 14.4002C4 16.1675 5.43269 17.6002 7.2 17.6002Z"
    />
    <path
      d="M14.8 20.0002C15.9046 20.0002 16.8 19.1048 16.8 18.0002C16.8 16.8957 15.9046 16.0002 14.8 16.0002C13.6954 16.0002 12.8 16.8957 12.8 18.0002C12.8 19.1048 13.6954 20.0002 14.8 20.0002Z"
    />
    <path
      d="M15.2 13.6002C17.851 13.6002 20 11.4512 20 8.80024C20 6.14928 17.851 4.00024 15.2 4.00024C12.549 4.00024 10.4 6.14928 10.4 8.80024C10.4 11.4512 12.549 13.6002 15.2 13.6002Z"
    />
  </g>
</template>
